import React from 'react'
import RightArrow from '../../../assets/components/RightArrow'
import Overview from '../../../assets/images/eulerity-art/Overview.png'
import { Link } from 'gatsby'

const Success = () => {
    return (
        <section className='py-32 px-8 sm:px-[58px] md:px-[68px] lg:px-[90px] xl:px-32'>
            <div className='bg-brandGrayBlue30 flex flex-col gap-16 p-8 sm:p-16 rounded-xl max-w-[1262px] xl:flex-row 2xl:m-auto'>
                <div className='flex flex-col gap-6 items-center text-center xl:text-start xl:items-start xl:justify-center'>
                    <p className='headerText2'>Proof of Success</p>
                    <p className='text-fontSize5 text-brandDarkBlue1'>Don't just take our word for it. Our clients' successes speak to the power of Eulerity's approach. From significant ROI boosts to streamlined operations, see how businesses like yours have transformed with our platform.</p>
                    <Link className='flex items-center gap-2 text-brandPurple text-fontSize4-bold cursor-pointer w-fit' to='/company/content-hub/case-studies'>View Success Stories <RightArrow size={20} /> </Link>
                </div>
                <div className='max-w-[230px] tablet:max-w-[540px] desktop:max-w-[460px] m-auto'>
                    <img src={Overview} alt='app-overview' className='w-full h-auto object-cover object-center' />
                </div>
            </div>
        </section>
    )
}

export default Success